module.exports = __webpack_public_path__ + "img/inner_7_bg.137c3939.png";